var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompleteQuoteStatusIcon = function SvgCompleteQuoteStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#00D098",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D098",
    fillRule: "evenodd",
    d: "M19 20a4 4 0 0 1 4-4h8.343a4 4 0 0 1 2.829 1.172l1.656 1.656A4 4 0 0 1 37 21.657V34a4 4 0 0 1-4 4H23a4 4 0 0 1-4-4zm16 3v11a2 2 0 0 1-2 2H23a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h7v2a3 3 0 0 0 3 3zm-.11-2a2 2 0 0 0-.476-.757l-1.657-1.657A2 2 0 0 0 32 18.11V20a1 1 0 0 0 1 1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D098",
    fillRule: "evenodd",
    d: "M31.707 26.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L27 29.586l3.293-3.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
export { SvgCompleteQuoteStatusIcon as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/QuoteStatus/assets/complete-quote-status-icon.8d2cc8f056f569e471666bbd4e93a100.svg";